import { RouteRecordRawArgumented } from 'src/types/route'
import useI18n from 'src/hooks/i18n'

const { t } = useI18n()

const module: RouteRecordRawArgumented = {
  path: 'all-cross',
  name: 'allCross',
  redirect: () => ({ name: 'allCrossIndex' }),
  children: [
    {
      path: ':step?',
      name: 'allCrossIndex',
      component: () =>
        import(
          /* webpackChunkName: "all-cross-index" */ 'pages/all-cross/IndexPage.vue'
        ),
      meta: {
        breadcrumb: {
          name: t('breadcrumb.all_cross.index'),
          icon: 'mdi-table-arrow-right',
        },
        auth: {
          permission: 'all_cross_access',
        },
        inject: {
          params: {
            step: 'kparts',
          },
        },
      },
    },
  ],
}

export default module
